import { deserialize, Http, HttpConfig, HttpError } from '@ezio/http'

import { createEventHook } from '@vueuse/core'
import { underscoreKeysToCamelCase } from '@ezio/utils'

const loggingOut = createEventHook<any>()
const permissionDenied = createEventHook<any>()

const config: HttpConfig = {
    url: import.meta.env.VITE_EZIO_API_URL,
    version: 'v1'
}

let api: API = null

export const useEzioAPI = () => {
    if (!api) {
        api = new API(config)
    }

    return {
        api
    }
}

class API extends Http {
    public tokensStore = null

    public constructor(config: HttpConfig) {
        super()
        this.config = config
    }

    protected getRequestHeaders() {
        const headers = {
            Accept: 'application/json',
            'Cache-Control': 'no-store no-cache must-revalidate',
            'Access-Token': this.tokensStore.tokens.accessToken,
            Client: this.tokensStore.tokens.client,
            Uid: this.tokensStore.tokens.uid
        }
        return headers
    }

    protected async onSuccess(response: any) {
        this.tokensStore.storeTokens(response.headers)
        if (response.data.cursor) {
            return response
        }
        const r: any = {
            data: await deserialize(response.data),
            meta: underscoreKeysToCamelCase(response.data.meta)
        }

        return r
    }

    protected onError(error: HttpError): HttpError {
        if (error.status === 401) {
            console.warn('401 : logging out')

            this.tokensStore.reset()

            loggingOut.trigger(error.message)
        }

        if (error.status === 403) {
            permissionDenied.trigger(error.message)
        }

        return super.onError(error)
    }

    public onLoggingOut(params: any) {
        return loggingOut.on(params)
    }

    public onPermissionDenied(params: any) {
        return permissionDenied.on(params)
    }
}

// const init = (config: HttpConfig) => {
//     api = new API(config)
//     return api
// }
